module.exports = __webpack_public_path__ + "static/media/man_xuhua.75d1caaf.png";